import axios from "axios";
import { baseUrlAPI } from "@/config/api";

const HOST = baseUrlAPI;

export default {
	get(payload = {}) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/paises`,
        method: "get"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  getById(payload = {}) {
    const paisId = payload.paisId || "";

    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/paises/${paisId}`,
        method: "get"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  put(payload = {}) {
    const paisId = payload.paisId;
    const data = payload.data || {};

    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/paises/${paisId}`,
        method: "put",
        data
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  post(payload = {}) {
        const data = payload.data || {};
        return new Promise((resolve, reject) => {
          axios({
            url: `${HOST}/paises`,
            method: "post",
            data
          })
            .then(response => resolve(response))
            .catch(error => reject(error));
        });
      },
  delete(payload = {}) {
        const paisId = payload.paisId;
        return new Promise((resolve, reject) => {
          axios({
            url: `${HOST}/paises/${paisId}`,
            method: "delete",
          })
            .then(response => resolve(response))
            .catch(error => reject(error));
        });
      },
}